/**
 * Converts a form date (MM/DD/YYYY) to YYYY-MM-DD for API / BigQuery persistence.
 *
 * @param dateStr - Date string from the form, typically MM/DD/YYYY
 * @returns ISO-style date string (YYYY-MM-DD), or the original value if parsing fails
 */
export const convertFormDateToStorageFormat = (dateStr: string): string => {
  if (!dateStr.trim()) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return dateStr.slice(0, 10);
  }

  const parts = dateStr.split("/");
  if (parts.length !== 3) {
    return dateStr;
  }

  const [month, day, year] = parts;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};
